import React from 'react'
import { Link } from 'react-router-dom'

function HomeCards({userId, zone, url, imageSrc, vehicleCount}) {

    const box = (
        <>
        <div className='homecard-img'>
          <img  src={imageSrc} style={{height:"60px",width:"60px"}} alt="" />
        </div>
        
        <div style={{paddingLeft:"10px",marginTop:"10px"}}>
          <h3>{zone}</h3><h6>Vehicles: {vehicleCount}</h6>
        </div>
        </>
    )
  return (
    userId == null ? (
        <div class="col-md-3 mb-3">
        <div class="cardBox">
        <Link
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          href="/"
          className="text-decoration-none text-black"
        >
          {box}
        </Link></div></div>
      ) : (
        <div class="col-md-3 mb-3">
        <div class="cardBox">
        <Link to={url} className="text-decoration-none text-black">
          {box}
        </Link>
        </div></div>
      )
  )
}

export default HomeCards